import React from 'react';
import { Package, Star, TrendingUp } from 'lucide-react';
import { brands } from '../data/mock';
import { PageSEO } from '../components/PageSEO';

const Brands = () => {
  return (
    <div className="min-h-screen pt-20">
      <PageSEO path="/marcas" />
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-teal-600 via-emerald-600 to-teal-700 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl sm:text-6xl font-bold mb-6">
              Marcas que Distribuimos
            </h1>
            <p className="text-xl sm:text-2xl text-teal-100 leading-relaxed">
              Representamos marcas líderes en el mercado ecuatoriano
            </p>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block p-3 bg-emerald-100 rounded-full mb-6">
            <Star className="text-emerald-600" size={32} />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
            Alianzas Estratégicas
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Trabajamos con las marcas más reconocidas del mercado, garantizando su presencia 
            en todos los puntos de venta clave. Nuestro compromiso es el crecimiento mutuo 
            y la ejecución comercial de excelencia.
          </p>
        </div>
      </section>

      {/* Brands Grid */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {brands.map((brand) =>
            <div
              key={brand.id}
              className="group relative p-8 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-emerald-500">

                <div className="flex flex-col items-center justify-center h-full">
                  <div className="w-full h-32 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform duration-300">
                    <img
                    src={brand.logo}
                    alt={brand.name}
                    className="max-w-full max-h-full object-contain" />

                  </div>
                  <h3 className="text-xl font-bold text-gray-900 text-center mb-2">
                    {brand.name}
                  </h3>
                  <span className="inline-block px-3 py-1 bg-emerald-100 text-emerald-700 rounded-full text-xs font-semibold">
                    {brand.category}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-600 to-teal-600 rounded-xl opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">¿Por Qué Trabajar con NOSOTROS?

            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Ofrecemos valor agregado a nuestras marcas aliadas
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-8 rounded-2xl bg-gradient-to-br from-emerald-50 to-teal-50 hover:shadow-lg transition-shadow">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-emerald-600 to-teal-600 rounded-full mb-6">
                <Package size={28} className="text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Respaldo Exclusivo
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Compromiso total con el éxito de cada marca, trabajando como una extensión 
                de tu equipo comercial en el territorio.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-gradient-to-br from-teal-50 to-emerald-50 hover:shadow-lg transition-shadow">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-teal-600 to-emerald-600 rounded-full mb-6">
                <TrendingUp size={28} className="text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Crecimiento Conjunto
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Estrategias comerciales personalizadas que impulsan las ventas y la 
                presencia de marca en el mercado regional.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-gradient-to-br from-emerald-50 to-teal-50 hover:shadow-lg transition-shadow">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-emerald-600 to-teal-600 rounded-full mb-6">
                <Star size={28} className="text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Ejecución de Excelencia
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Merchandising profesional, gestión de inventarios y seguimiento continuo 
                en cada punto de venta.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-emerald-600 to-teal-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            ¿Quieres que tu Marca sea Parte?
          </h2>
          <p className="text-xl text-emerald-100 mb-8 leading-relaxed">
            Únete a nuestro portafolio de marcas líderes y expande tu presencia en el centro del Ecuador
          </p>
          <a
            href="/contacto"
            className="inline-block px-8 py-4 bg-white text-emerald-700 font-semibold rounded-lg hover:bg-emerald-50 transition-all duration-200 shadow-lg hover:shadow-xl">

            Conversemos Sobre tu Marca
          </a>
        </div>
      </section>
    </div>);

};

export default Brands;